module.exports = __webpack_public_path__ + "static/media/work-presentation.ad21a82b.png";